import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'role',
	standalone: false
})
export class RolePipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) {
			return '';
		}

		return value
			.replace(/-/g, ' ')
			.split(/\s+/)
			.filter(Boolean)
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	}
}
